import { i18n, registerI18nBundle } from '@cyberint/common-utils';
import resources from './resources';

const NAMESPACE = 'campaigns';

registerI18nBundle({
  namespace: NAMESPACE,
  en: resources,
  loaders: {
    es: () => import(/* webpackChunkName: "common-campaigns-i18n-locale-es" */ './locales/es'),
    fil: () => import(/* webpackChunkName: "common-campaigns-i18n-locale-fil" */ './locales/fil'),
    ja: () => import(/* webpackChunkName: "common-campaigns-i18n-locale-ja" */ './locales/ja'),
    th: () => import(/* webpackChunkName: "common-campaigns-i18n-locale-th" */ './locales/th')
  }
});

export const campaignsT = i18n.getFixedT(null, null, NAMESPACE);
